export default __webpack_public_path__ + "static/media/dr-chandan-new.1d2fc985.jpg";